const sushiswap = require("./sushiswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  USDT: "0xb020d981420744f6b0fedd22bb67cd37ce18a1d5",
  CELO: "0x471ece3750da237f93b8e339c536989b8978a438",
  WETH: "0x122013fd7df1c6f636a5bb8f03108e876548b455",
  USDC: "0xef4229c8c3250c675f21bcefa42f58efbff6002a",
  cUSD: "0x765de816845861e75a25fca122bb6898b8b1282a",
  DAI: "0xe4fe50cdd716522a56204352f00aa110f731932d",
  SUSHI: "0x29dfce9c22003a4999930382fd00f9fd6133acd1"
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.cUSD]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.DAI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.WETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.USDT]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.CELO]: 18,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WETH;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.CELO;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  USD_ORACLE_TOKEN: TOKEN_SYMBOL_TO_ADDRESS.cUSD,
  UNIV2_ROUTER_ADDRESS: "0x1421bDe4B10e8dd459b3BCb598810B1337D56842",
  NATIVE_TOKEN,
  PROTOCOLS: {
    sushiswap,
  }
};
